export default __webpack_public_path__ + "static/media/video-recorder.e269fb0a.svg";